<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-container>
        <v-row>
          <!-- Columna de redes sociales -->
          <v-col cols="12" md="6" class="text-center">
            <v-card-text>
              <v-btn
                v-for="(icon, i) in icons"
                :key="i"
                class="contact-btn text-none white--text"
                color="transparent"
                dark
                elevation="0"
                :href="icon.link"
                target="_blank"
              >
                <v-icon class="mr-2" size="24px">{{ icon.text }}</v-icon>
                {{ icon.name }}
              </v-btn>
            </v-card-text>
          </v-col>
          <!-- Columna de datos de contacto con botones -->
          <v-col cols="12" md="6" class="text-left">
            <v-card-text>
              <v-btn
                class="contact-btn"
                color="transparent"
                dark
                :href="'tel:+5214434846542'"
              >
                <v-icon class="mr-2">mdi-phone</v-icon> +52 1 443 484 6542
              </v-btn>
              <v-btn
                class="contact-btn"
                color="transparent"
                dark
                :href="'https://www.google.com/maps/search/?api=1&query=Mozart+555,+Col+La+Loma'"
                target="_blank"
              >
                <v-icon class="mr-2">mdi-map-marker</v-icon> Mozart 555, Col. La
                Loma
              </v-btn>
              <v-btn
                class="contact-btn"
                color="transparent"
                dark
                :href="'mailto:moziraram@gmail.com'"
              >
                <v-icon class="mr-2">mdi-email</v-icon> moziraram@gmail.com
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>

      <v-divider></v-divider>

      <!-- Mensaje final -->
      <v-card-text class="white--text">
        Transformando el futuro digital, un paso a la vez.
      </v-card-text>

      <v-card-text class="white--text pt-0">
        {{ new Date().getFullYear() }} — <strong>Didocu</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
.contact-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  text-transform: none;
  font-size: 14px;
  border: none; /* Elimina cualquier borde */
  box-shadow: none; /* Elimina cualquier sombra */
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        text: "mdi-facebook",
        name: "Órdenes de Servicio Automotriz Premium a la Medida",
        link: "https://www.facebook.com/profile.php?id=61572530822082",
      },
      {
        text: "mdi-instagram",
        name: "ordenes_de_servicio_digital",
        link: "https://www.instagram.com/ordenes_de_servicio_digital/",
      },
      {
        text: "mdi-youtube",
        name: "Órdenes de Servicio Digital (OSD)",
        link: "https://www.youtube.com/@OSD-didocu",
      },
    ],
  }),
};
</script>

<style scoped>
.v-card {
  width: 100%;
}
.contact-info p {
  margin: 5px 0;
  font-size: 14px;
  color: white;
}
</style>
